import { twMerge } from 'tailwind-merge';

const VARIANT = { line: 'h-4 w-full', block: 'h-48 w-full', row: 'h-14 w-full' };

/**
 * Placeholder shaped like the content it stands for (DESIGN.md §11.1). A highlight sweeps across
 * it while it waits; with reduced motion it stays a static bar.
 */
export function Skeleton({
  variant = 'line',
  className,
}: {
  variant?: keyof typeof VARIANT;
  className?: string;
}) {
  return (
    <div
      aria-hidden="true"
      className={twMerge(
        'relative overflow-hidden rounded bg-gray-100 dark:bg-gray-900',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-linear-to-r before:from-transparent before:via-white/70 before:to-transparent dark:before:via-white/5 motion-reduce:before:animate-none',
        VARIANT[variant],
        className,
      )}
    />
  );
}
